$(document).ready(function() {
  //
  // ─── NAVIGATION TOGGLE ──────────────────────────────────────────────────────────
  //

  var hamburger = document.querySelector(".hamburger");
  hamburger.addEventListener("click", function() {
    hamburger.classList.toggle("is-active");
  });

  //
  // ─── TOP BANNER SLIDER ──────────────────────────────────────────────────────────
  //

  $(".top-slider").owlCarousel({
    loop: true,
    // margin: 10,
    nav: false,
    dots: true,
    // dotsContainer: "#carousel-custom-dots",
    items: 1,
    autoplay: true,
    lazyLoad: true
  });

  //
  // ─── NEWS CAROUSEL ──────────────────────────────────────────────────────────────
  //

  $(".news-carousel").owlCarousel({
    loop: false,
    // margin: 10,
    lazyLoad: true,
    nav: true,
    dots: true,
    // dotsContainer: '#carousel-custom-dots',
    navText: ["<span></span>", "<span></span>"],
    autoplay: false,
    animateIn: "fadeIn",
    animateOut: "fadeOut",
    autoplay: 3000, // time for slides changes
    smartSpeed: 1000, // duration of change of 1 slide
    lazyLoad: true,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      991: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });
  var $opinion = $('#opinion.owl-carousel');
  $opinion.owlCarousel({
    loop: false,
    lazyLoad: false,
    autoplay: false,
      items: 1,
      autoHeight:true,
    pagination: false,
    URLhashListener:true,


  });
    $opinion.on('changed.owl.carousel', function(e) {
        location.hash =  e.property.value;
        var h = e.property.value;
        $('.pagiation .it').removeClass('active');
        var w = "#" + h;

        $('.pagiation a[href="'+ w +'"]').addClass('active');

    });

  $('.arrow_container .arrow_right').click(function(e) {
    $('.pagiation .it').removeClass('active');
    $opinion.trigger('next.owl.carousel');
      location.hash =  e.property.value;
      var h = e.property.value;
      $('.pagiation .it').removeClass('active');
      var w = "#" + h;

      $('.pagiation a[href="'+ w +'"]').addClass('active');

  });
  $('.arrow_container .arrow_left').click(function(e) {
    $('.pagiation .it').removeClass('active');

    $opinion.trigger('prev.owl.carousel');
      location.hash =  e.property.value;
      var h = e.property.value;
      $('.pagiation .it').removeClass('active');
      var w = "#" + h;

      $('.pagiation a[href="'+ w +'"]').addClass('active');
  });
    $('.pagiation .it').on('click',function () {
        $('.pagiation .it').removeClass('active');
        $(this).addClass('active');
    });
$('.galery_photo').fancybox();

    $('.pagiation a[href="#0"]').addClass('active');
  var footer_slider = $('.footer_galerry_content');
  footer_slider.owlCarousel({
    loop: false,
    lazyLoad: true,
    autoplay: false,
    animateIn: "fadeIn",
    animateOut: "fadeOut",
    autoplay: 3000, // time for slides changes
    smartSpeed: 1000, // duration of change of 1 slide
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 3
      },
      991: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
  });
  var max = 0;
  $('.why_item').each(function () {
     if(max < $(this).height()) {
         max=$(this).height();
     }
  });
    $('.why_item').each(function () {
            $(this).height(max);
    });
    $('.menu-item.oferta').click(function () {
        $(this).find('.sub-menu').show();
    });
    $('.oferta a').click(function () {
        $(this).parent().find('.sub-menu').toggle();
    });
    var mx =0;
    $('.galery_item').each(function () {
      if($(this).height()>mx) {
        mx = $(this).height();
      }
    });
    $('.galery_item').each(function () {
      $(this).height(mx);
    });
    $('.blocks-gallery-item a').each(function () {
      $(this).addClass("grouped_elements")
      $(this).attr("rel", "gallery");
    });
  $('.blocks-gallery-item a').fancybox();
});

//
// ─── FADE ON PAGE LOAD ───────────────────────────────────────────────────────────────
//

$(window).on("load", function() {
  $("main").addClass("loaded");
});


function checkForChanges()
{
    if ($('#opinion.owl-carousel .owl-item').hasClass('active'))
        console.log(($(this).find('.item').data("hash")));
    else
        setTimeout(checkForChanges, 500);
}
